import { useEffect, useState } from "react";

/** Arma el mensaje: n pendientes (singular/plural) o el texto final cuando n = 0. */
export const felMsg = (n, verbo, sing, plur, fin) => ({
  id: Date.now() + Math.random(),
  completo: n <= 0,
  texto: n <= 0 ? fin : `Te ${n === 1 ? "falta" : "faltan"} ${verbo} ${n} ${n === 1 ? sing : plur}`,
});

/** Mensaje grande centrado tras cada escaneo correcto. No bloquea el escáner (sin clics). */
export const Felicidades = ({ msg }) => {
  const [vis, setVis] = useState(false);
  useEffect(() => {
    if (!msg) return undefined;
    setVis(true);
    const t = setTimeout(() => setVis(false), 2800);
    return () => clearTimeout(t);
  }, [msg]);
  if (!msg || !vis) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none" data-testid="felicidades">
      <div key={msg.id} className={`w-full max-w-md rounded-3xl border-4 p-6 text-center shadow-2xl animate-in zoom-in-75 duration-300 ${msg.completo ? "bg-emerald-600 border-emerald-300 text-white" : "bg-amber-300 border-amber-500 text-black"}`}>
        <div className="text-3xl sm:text-6xl font-black tracking-tight leading-none" data-testid="felicidades-titulo">{msg.titulo || "¡FELICIDADES! 🎉"}</div>
        <div className="mt-4 text-3xl sm:text-4xl font-black leading-tight uppercase" data-testid="felicidades-texto">{msg.texto}</div>
      </div>
    </div>
  );
};
